import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useFormContext } from 'react-hook-form';

type AddOfferControlsProps = {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  handleSubmit: () => void;
  editMode?: boolean;
  disabled?: boolean;
};

export const AddOfferControls = ({
  currentStep,
  setCurrentStep,
  handleSubmit,
  editMode = false,
  disabled = false,
}: AddOfferControlsProps) => {
  const { t } = useTranslations();

  const form = useFormContext();

  const isDualEducation = form.watch('dual_education');

  return (
    <div
      className={cn(
        'flex w-full flex-col-reverse items-center gap-2 px-8 md:flex-row md:justify-end md:gap-2 md:px-0',
        !!currentStep && 'md:justify-between',
      )}
    >
      {!!currentStep && !isDualEducation && (
        <Button
          type="button"
          variant={'link'}
          onClick={() => {
            if (isDualEducation && currentStep === 3) {
              setCurrentStep(currentStep - 3);
            } else {
              setCurrentStep(currentStep - 1);
            }
            scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }}
          disabled={disabled}
        >
          {t('text1026')}
        </Button>
      )}
      {currentStep != 4 && !isDualEducation && (
        <Button
          type="button"
          className="w-full md:w-auto"
          onClick={() => {
            if (isDualEducation && currentStep === 0) {
              setCurrentStep(currentStep + 3);
            } else {
              setCurrentStep(currentStep + 1);
            }
            scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }}
          disabled={disabled}
        >
          {t('text1027')}
        </Button>
      )}
      {(currentStep === 4 || editMode || isDualEducation) && (
        <Button
          type="button"
          className="w-full md:w-auto"
          onClick={() => handleSubmit()}
          disabled={disabled}
        >
          {t('text1729')}
        </Button>
      )}
    </div>
  );
};
